<template>
  <div>
    <div class="row">
      <div class="col-9 text-left">
        <span
          v-if="currentDate"
          class="date ml-4">{{ getDateString }}</span>
      </div>
      <div class="col-3">
        <div class="clock-container row-item-with-left-border">
          <i
            :class="{'red-clock': showRedClock, 'orange-clock': showOrangeClock, 'green-clock': showGreenClock, 'gray-clock': showGrayClock}"
            class="far fa-clock"
            @click="clockOnClick"/>
        </div>
      </div>
    </div>
    <div class="row-item-with-border mt-2 mb-4" />
    <div v-if="dateItems">
      <div
        v-for="(item, index) in dateItems"
        :key="index"
        class="row">
        <div class="col-4 text-left">
          <div
            v-if="item.allDay"
            class="pl-3">{{ $t('CALENDAR.ALLDAY') }}</div>
          <div
            v-else
            class="pl-3">{{ getHours(item.startDate) }}</div>
        </div>
        <div class="col-8 text-left row-item-with-left-border">
          <div>{{ item.name }}</div>
        </div>
      </div>
    </div>
</div></template>

<script>
import moment from 'moment';

export default {
  name: 'CalendarDay',
  components: {},
  props: {
    currentDate: {
      type: Object,
      default: null,
    },
    dateItems: {
      type: Array,
      default: () => [],
    },
    showGreenClock: {
      type: Boolean,
      default: false,
    },
    showOrangeClock: {
      type: Boolean,
      default: false,
    },
    showRedClock: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getDateString() {
      const newD = moment(this.currentDate.format('YYYY-MM-DD'));
      return newD.format('LL');
    },
    showGrayClock() {
      return (
        !this.showRedClock && !this.showOrangeClock && !this.showGreenClock
      );
    },
  },
  methods: {
    getHours(date) {
      const h = moment(date);
      return h.format('h:mm');
    },
    clockOnClick() {
      this.$router.push('/dashboard');
    },
  },
};
</script>

<style scoped lang="scss">
.date {
  font-size: 1.75rem;
}
.clock-container {
  display: flex;
  height: 100%;
  align-items: center;
}
.fa-clock:hover {
  cursor: pointer;
}
.fa-clock {
  margin: auto;
}
.gray-clock {
  color: gray;
}
.red-clock {
  color: red;
}
.orange-clock {
  color: orange;
}
.green-clock {
  color: green;
}
</style>
